export default function otherPlayer(player) {
  if (!['a', 'b'].includes(player)) {
    throw new Error('Player must be \'a\' or \'b\'');
  }
  if (player === 'a') {
    return 'b';
  }
  return 'a';
}
